'use client';

import { getStoreInstance } from '@/store';
import { selectCurrencySettled } from '@/domain/currency/selectors';

/**
 * 客户端确定稳定的 cyy 接口参数
 * 从 Zustand Store 中获取 currency 信息
 */
export function getStableClientCyyInfo(forceDisabled?: boolean): object {
  if (forceDisabled) return {};
  const storeInstance = getStoreInstance();
  if (storeInstance) {
    const state = storeInstance.getState();
    if (state) {
      const currencySettled = selectCurrencySettled(state);
      if (currencySettled && state.currency && state.currency.name) {
        return { cyy: state.currency.name };
      }
    }
  }
  return {};
}
